import { ROUTE, axiosInstance } from '@/core/api/axiosInstance';
import {
  GeopoliticalTraderDB,
  TradeFlowItemDB,
  TradeFlowItemSupplyChainDB,
} from '@/server/services/GoogleBigQuery/BigQueryTradeClient.types.db';

export const trade = {
  getFlows: async (year: number) => {
    const { data } = await axiosInstance.get<Array<TradeFlowItemDB | TradeFlowItemSupplyChainDB>>(ROUTE.TRADE.FLOWS, {
      params: { year },
    });
    return data;
  },
  getFlowYears: async () => {
    const { data } = await axiosInstance.get<number[]>(ROUTE.TRADE.FLOWS_YEARS);
    return data;
  },
  getGeopoliticalTraders: async () => {
    const { data } = await axiosInstance.get<GeopoliticalTraderDB[]>(ROUTE.TRADE.GEOPOLITICAL_TRADERS);
    return data;
  },
};
